import { createAction, props } from '@ngrx/store';

import { CarrierLookupResponseBody } from '#types/carrier';
import { ErrorResponse } from '#types/core';
import { Filters, Sorts } from '#types/grid';
import { ListOfValuesResponse } from '#types/list';

//
// request lists
//

export const RequestLists = createAction('[Carrier.List] - Request Lists');

//
// carrier list
//
export const RequestCarrierList = createAction('[Carrier.List] - Request Carrier List');
export const RequestCarrierListSuccess = createAction(
  '[Carrier.List] - Request Carrier List Success',
  props<{ list: ListOfValuesResponse }>()
);
export const RequestCarrierListFailure = createAction('[Carrier.List] - Request Carrier List Failure', props<{ error: ErrorResponse }>());

//
// delivery service code list
//

export const RequestDeliveryServiceCodeList = createAction(
  '[Carrier.List] - Request Carrier Delivery Service Code List',
  props<{ carrier: string }>()
);
export const RequestDeliveryServiceCodeListSuccess = createAction(
  '[Carrier.List] - Request Carrier Delivery Service Code List Success',
  props<{ carrier: string; list: ListOfValuesResponse }>()
);
export const RequestDeliveryServiceCodeListFailure = createAction(
  '[Carrier.List] - Request Carrier Delivery Service Code List Failure',
  props<{ error: ErrorResponse }>()
);

//
// special service list
//

export const RequestSpecialServiceList = createAction(
  '[Carrier.List] - Request Carrier Special Service List',
  props<{ carrier: string; serviceCode: string }>()
);
export const RequestSpecialServiceListSuccess = createAction(
  '[Carrier.List] - Request Carrier Special Service List Success',
  props<{ carrier: string; serviceCode: string; list: ListOfValuesResponse }>()
);
export const RequestSpecialServiceListFailure = createAction(
  '[Carrier.List] - Request Carrier Special Service List Failure',
  props<{ error: ErrorResponse }>()
);

//
// carrier / lookup dialog
//

export const CarrierLookupDialogRequestData = createAction('[Carrier.Lookup.Dialog] - Grid Request Data', props<{ id: string }>());
export const CarrierLookupDialogRequestDataWithParameters = createAction(
  '[Carrier.Lookup.Dialog] - Grid Request Data With Parameters',
  props<{ id: string; filters: Filters; page: number; first: number; rows: number; sorts: Sorts }>()
);
export const CarrierLookupDialogRequestDataWithFilters = createAction(
  '[Carrier.Lookup.Dialog] - Grid Request Data With Filters',
  props<{ id: string; filters: Filters }>()
);
export const CarrierLookupDialogRequestDataSuccess = createAction(
  '[Carrier.Lookup.Dialog] - Grid Request Data Success',
  props<{ id: string; data: CarrierLookupResponseBody }>()
);
export const CarrierLookupDialogRequestDataFailure = createAction(
  '[Carrier.Lookup.Dialog] - Grid Request Data Failure',
  props<{ id: string }>()
);
